import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const images = [
  {
    link: "https://youtu.be/bG9M9-UTvF8?feature=shared",
    img: "images/dance_gigi.gif",
    price: "参考(Estimated Fee)：50,000円($500)",
  },
  {
    link: "https://www.pixiv.net/artworks/117134908",
    img: "images/Fauna_HBD_.gif",
    price: "参考(Estimated Fee)：50,000円($500)",
  },
  {
    link: "https://www.pixiv.net/artworks/126421372",
    img: "images/nimi.gif",
    price: "参考(Estimated Fee)：30,000円($300)",
  },
  {
    link: "https://www.pixiv.net/artworks/115471042",
    img: "images/Gura_CatChip.gif",
    price: "参考(Estimated Fee)：50,000円($500)",
  },
  {
    link: "https://www.pixiv.net/artworks/120662922",
    img: "images/Raora-oo2.gif",
    price: "参考(Estimated Fee)：30,000円($300)",
  },
  {
    link: "https://www.pixiv.net/artworks/123642139",
    img: "images/olli_rice.gif",
    price: "参考(Estimated Fee)：30,000円($300)",
  },
  {
    link: "https://www.pixiv.net/artworks/125155776",
    img: "images/fuwawa_zombi.gif",
    price: "参考(Estimated Fee)：30,000円($300)",
  },
  {
    link: "https://youtu.be/uk5QneY397c?feature=shared",
    img: "images/CC_carbi.gif",
    price: "参考(Estimated Fee)：30,000円($300)",
  },
  {
    link: "https://www.pixiv.net/artworks/122380248",
    img: "images/main_1.gif",
    price: "参考(Estimated Fee)：30,000円($300)",
  },
  {
    link: "https://youtu.be/pTaLqMrVK68?feature=shared",
    img: "images/raora_pizza.gif",
    price: "参考(Estimated Fee)：30,000円($300)",
  },
  {
    link: "https://youtu.be/QkHR4tpe8I0?feature=shared",
    img: "images/gigi_feed.gif",
    price: "参考(Estimated Fee)：30,000円($300)",
  },
  {
    link: "https://www.pixiv.net/artworks/120275081",
    img: "images/kiwawaHPB2024.gif",
    price: "参考(Estimated Fee)：50,000円($500)",
  },
  {
    link: "https://www.pixiv.net/artworks/127669764",
    img: "images/main_momi.gif",
    price: "参考(Estimated Fee)：30,000円($300)",
  },
  {
    link: "https://youtu.be/p5GYbT-V3Go?feature=shared",
    img: "images/FuwaMoco_main.gif",
    price: "参考(Estimated Fee)：50,000円~($500~)",
  },
  {
    link: "https://youtu.be/zDu8j-mDPwg?feature=shared",
    img: "images/mococo.gif",
    price: "参考(Estimated Fee)：50,000円~($500~)",
  },
  {
    link: "https://youtu.be/9QLmggZRpCg?feature=shared",
    img: "images/blingbangbang.gif",
    price: "参考(Estimated Fee)：50,000円~($500~)",
  },
  {
    link: "https://youtu.be/jd4y3yHyV7M?feature=shared",
    img: "images/valen.gif",
    price: "参考(Estimated Fee)：50,000円($500)",
  },
  {
    link: "https://youtu.be/quOrXzvvsrw?feature=shared",
    img: "images/GuraHpb2024.gif",
    price: "参考(Estimated Fee)：50,000円~($500~)",
  },
  {
    link: "https://youtu.be/T4cU120PKVs?feature=shared",
    img: "images/Ame_dance.gif",
    price: "参考(Estimated Fee)：30,000円($300)",
  },
  {
    link: "https://youtu.be/894b8zb6upQ?feature=shared",
    img: "images/kiara_pokedance.gif",
    price: "参考(Estimated Fee)：50,000円($500)",
  },
  {
    link: "https://youtu.be/PJI5nR8fYF8?feature=shared",
    img: "images/ina_HPB.gif",
    price: "参考(Estimated Fee)：30,000円($300)",
  },
];

function SliderGallery() {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const settings = {
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    dots: false,
    centerMode: true,
    focusOnChange: true,

    responsive: [
      {
        breakpoint: 768, // タブレットサイズ以下
        settings: {
          slidesToShow: 1, // スライドを1つ表示
        },
      },
      {
        breakpoint: 480, // スマートフォンサイズ以下
        settings: {
          slidesToShow: 1, // スライドを1つ表示
          centerMode: false, // センターモードを無効
        },
      },
    ],
  };

  return (
    <Slider {...settings}>
      {images.map((item, index) => (
        <div
          key={index}
          className="gallery-item"
          onMouseEnter={() => setHoveredIndex(index)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <a href={item.link} target="_blank" rel="noopener noreferrer">
            <img src={item.img} alt="Artwork" style={{ width: "90%" }} />
          </a>
          {hoveredIndex === index && (
            <div className="price-popup">{item.price}</div>
          )}
        </div>
      ))}
    </Slider>
  );
}

export default SliderGallery;
